'use client';

import React, { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import Login, { LoginProps } from 'components/commercetools-ui/organisms/authentication/login';
import Redirect from 'helpers/redirect';
import { useAccount, useCart } from 'frontastic/hooks';
import { TasticProps } from 'frontastic/tastics/types';

const AccountLoginTastic = ({ data }: TasticProps<LoginProps>) => {
  const searchParams = useSearchParams();

  const lvp = searchParams.get('lvp');
  const rturl = searchParams.get('rturl');

  //redirection link after user is logged in
  const redirectLink = useMemo(() => {
    const lastVisitedPage = lvp ? `/${lvp}` : data.accountLink;
    return lastVisitedPage;
  }, [data.accountLink, lvp]);

  const { loggedIn } = useAccount();
  const { data: cartData } = useCart();
  const hasCart = cartData?.lineItems ? cartData.lineItems.length > 0 : false;

  if (rturl) {
    return <Redirect target={`/${rturl}`} />;
  }

  return (
    <div className="mb-36 md:mb-56 lg:mb-84">
      <Login {...data} />
      {loggedIn && hasCart && <Redirect target={'/cart'} />}
      {loggedIn && !hasCart && <Redirect target={redirectLink} />}
    </div>
  );
};

export default AccountLoginTastic;
